import { Container } from '@mui/material';
import { discoveryAwsApi } from 'services/api/discovery';
import DiscoveryHeader from './components/DiscoveryHeader';
import DiscoverySections from './components/DiscoverySections/DiscoverySections';
import ErrorMessage from './components/ErrorMessage';
import CircularLoading from './components/CircularLoading';

const Discovery = () => {
  const { data, isLoading, error } = discoveryAwsApi.useGetPageDataQuery();

  const displaySections = !isLoading && !error && data;

  return (
    <Container maxWidth="bigContainer">
      <DiscoveryHeader />
      {error && <ErrorMessage />}
      {isLoading && <CircularLoading />}

      {displaySections && <DiscoverySections sections={data} />}
    </Container>
  );
};

export default Discovery;
